module.exports = __webpack_public_path__ + "media/full.ff2938b9.wav";